export default "__VITE_ASSET__BH1FT5BS__"